import { render, staticRenderFns } from "./privilegeCouponEdit.vue?vue&type=template&id=dcf38e12"
import script from "./privilegeCouponEdit.vue?vue&type=script&lang=js"
export * from "./privilegeCouponEdit.vue?vue&type=script&lang=js"
import style0 from "./privilegeCouponEdit.vue?vue&type=style&index=0&id=dcf38e12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports